// reservebar-product-summer.js
import { getReservebarLabel, getLiquidAddressString } from './reservebar-config';
import {
	generateCartSettings,
	generateCartTemplateBody
} from './reservebar-cart-modal';

export function generateProductSummer(liquidGroupingID, productSummer, meta = {}) {
	const block = document.createElement('div');
	const shippingAddress = getLiquidAddressString();
	block.className = 'reservebar-product-summer';

	if (shippingAddress) {
		block.innerHTML = generateCartTemplateBody();
	} else {
		block.innerHTML = `
		<div class="reservebar-product-summer__info">
			<button class="reservebar-set-address-trigger"
					reservebar-liquid-id="${liquidGroupingID}"
				    data-product-title="${meta.title || ''}"
				    data-product-attr="${meta.attr || ''}">
				${getReservebarLabel(
			'reservebar_check_price_label',
			'Check Price and Availability'
		)}
			</button>
	 	</div>`;
	}

	productSummer.appendChild(block);
	generateCartSettings(liquidGroupingID, block, meta);
}
